// quote-card 纯 SVG 渲染。复用 tick.quoteRevealed 推导已揭示字符数。
import type { SceneData } from '../../api/types'
import type { QuoteData, QuoteBg } from './types'
import { quoteRevealed } from './tick'
import { COLORS, FONT_SANS, wrapText, textBlock } from '../../export/svgRender'

const BG: Record<QuoteBg, [string, string]> = {
  dark: ['#0f172a', '#1e293b'],
  warm: ['#2e1a0f', '#3d2010'],
  cool: ['#0f172a', '#1e3a5f'],
  minimal: ['#f8fafc', '#e2e8f0'],
}

export function render(data: SceneData, time: number, duration: number): string {
  const d = data as unknown as QuoteData
  const revealed = quoteRevealed(data, time, duration)
  const total = d.quote?.length ?? 0
  const done = revealed >= total
  const visible = done ? (d.quote || '') : (d.quote || '').substring(0, revealed)
  const minimal = d.background === 'minimal'
  const textColor = minimal ? '#1e293b' : COLORS.w
  const [c1, c2] = BG[d.background] || BG.dark

  const grad = `<defs><linearGradient id="qbg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient></defs>
  <rect x="0" y="0" width="1080" height="1920" fill="url(#qbg)"/>`

  const lines = wrapText(visible, 72, 840)
  const blockH = (lines.length - 1) * 72 * 1.45
  const textY = 1000 - blockH / 2

  return `${grad}
  <text x="540" y="520" font-size="200" fill="${COLORS.p}" text-anchor="middle" dominant-baseline="middle" font-family="Georgia,serif">&#8220;</text>
${textBlock(lines, 540, textY, 72, textColor, { anchor: 'middle', weight: 500, font: 'Georgia,serif', lineHeight: 1.45, style: 'italic' })}
  <text x="540" y="1500" font-size="44" font-weight="500" fill="${textColor}" opacity="0.75" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">— ${d.author ? d.author : ''}</text>`
}
